import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import dateFormat from 'date-fns/format';

import addMinutes from 'date-fns/addMinutes';
import addHours from 'date-fns/addHours';
import addDays from 'date-fns/addDays';
import addWeeks from 'date-fns/addWeeks';
import addMonths from 'date-fns/addMonths';
import addYears from 'date-fns/addYears';

import getTimestamp from 'date-fns/getTime';
import getSeconds from 'date-fns/getSeconds';
import getMinutes from 'date-fns/getMinutes';
import getDay from 'date-fns/getDay';
import getISODay from 'date-fns/getISODay';
import getHours from 'date-fns/getHours';
import getDate from 'date-fns/getDate';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';

import startOfDay from 'date-fns/startOfDay';
import startOfWeek from 'date-fns/startOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import startOfYear from 'date-fns/startOfYear';

import endOfDay from 'date-fns/endOfDay';

import subDays from 'date-fns/subDays';
import subWeeks from 'date-fns/subWeeks';
import subMonths from 'date-fns/subMonths';
import subYears from 'date-fns/subYears';

import endOfWeek from 'date-fns/endOfWeek';
import endOfMonth from 'date-fns/endOfMonth';

import isSameDay from 'date-fns/isSameDay';
import isSameWeek from 'date-fns/isSameWeek';
import isSameMonth from 'date-fns/isSameMonth';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';


import setSeconds from 'date-fns/setSeconds';
import setMinutes from 'date-fns/setMinutes';
import setHours from 'date-fns/setHours';

import differenceInDays from 'date-fns/differenceInDays';
import differenceInMonths from 'date-fns/differenceInMonths';
import differenceInWeeks from 'date-fns/differenceInWeeks';
import differenceInYears from 'date-fns/differenceInYears';
import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';

import getDaysInMonth from 'date-fns/getDaysInMonth'


import isNumber from "lodash/isNumber";

// import { enUS, uk, ru } from 'date-fns/locale';
import enUS from 'date-fns/locale/en-US';
import ru from 'date-fns/locale/ru';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import pt from 'date-fns/locale/pt-BR';
import es from 'date-fns/locale/es';
import uk from 'date-fns/locale/uk';
import tr from 'date-fns/locale/tr';
import ja from 'date-fns/locale/ja';
import ar from 'date-fns/locale/ar-SA';


let LOCALE = '';

let FORMAT = {};

const AM_FORMAT = {
  DATE_SIMPLE: "dd.MM.yyyy",
  AM_DATE_SIMPLE: "MMM d, yyyy",
  AM_DATE_S_SIMPLE: "MMM d",
  DATE_SIMPLE_MINUTES: "MM.dd.yyyy HH:mm",
  DATE_EXT: "MMMM d yyyy",
  AM_DATE_EXT: "EEE, MMM d, yyyy",
  DATE_FULL: "MMM dd yyyy",
  DATETIME: "MM/dd/yyyy HH:mm",
  TIME: "HH:mm",
  DATETIME_FULL: "MMM dd yyyy HH:mm",
  AM_DATETIME_FULL: "MMM d, yyyy HH:mm",
  DATETIME_ISO: "yyyy-MM-DDThh:mm:ss",
  MONTHNAME_FULL: "MMMM",
  DAYNAME_FULL: "dddd",
  WEEKDAY: "MMM dd yyyy, dd.",
  LABEL_WEEK: "MMM D",
  LABEL_DAY: "MMM D",
  CHART: {
    LABEL_MONTH: "MMM"
  }
};

const OTHER_FORMAT = {
  DATE_SIMPLE: "dd.MM.yyyy",
  AM_DATE_SIMPLE: "d MMM, yyyy",
  AM_DATE_S_SIMPLE: "d MMM",
  DATE_SIMPLE_MINUTES: "dd.MM.yyyy HH:mm",
  DATE_EXT: "d MMMM yyyy",
  AM_DATE_EXT: "EEE, d MMM, yyyy",
  DATE_FULL: "dd MMM yyyy",
  DATETIME: "dd/MM/yyyy HH:mm",
  TIME: "HH:mm",
  DATETIME_FULL: "dd MMM yyyy HH:mm",
  AM_DATETIME_FULL: "d MMM, yyyy HH:mm",
  DATETIME_ISO: "yyyy-MM-DDThh:mm:ss",
  MONTHNAME_FULL: "MMMM",
  DAYNAME_FULL: "dddd",
  WEEKDAY: "dd MMM yyyy, dd.",
  LABEL_WEEK: "D MMM",
  LABEL_DAY: "D MMM",
  CHART: {
    LABEL_MONTH: "MMM"
  }
};

const setLocale = (lang) => {
  switch (lang) {
    case 'en':
      FORMAT = AM_FORMAT;
      return LOCALE = enUS;

    case 'ru':
      FORMAT = OTHER_FORMAT;
      return LOCALE = ru;

    case 'de':
      FORMAT = OTHER_FORMAT;
      return LOCALE = de;

    case 'fr':
      FORMAT = OTHER_FORMAT;
      return LOCALE = fr;

    case 'pt':
      FORMAT = OTHER_FORMAT;
      return LOCALE = pt;

    case 'es':
      FORMAT = OTHER_FORMAT;
      return LOCALE = es;

    case 'ar':
      FORMAT = OTHER_FORMAT;
      return LOCALE = ar;

    case 'ja':
      FORMAT = OTHER_FORMAT;
      return LOCALE = ja;

    case 'tr':
      FORMAT = OTHER_FORMAT;
      return LOCALE = tr;

    case 'uk':
      FORMAT = OTHER_FORMAT;
      return LOCALE = uk;

    default:
      FORMAT = AM_FORMAT;
      return LOCALE = enUS;
  }
}

const getLocale = () => LOCALE;

const WORK_DAY_HOUR_START = 7;
const WORK_DAY_HOUR_END = 21;
const DAYS_IN_WEEK = 7;

const DAYS = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSHDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const getWeekDaysMapping = () => {
  const weekdays = [].concat(getLocale().localize.weekdays());
  weekdays.push(weekdays.shift())
};

const now = () => new Date();

const nMinutesFromNow = (minutes) => addMinutes(now(), minutes);

const nDaysFromNow = (days, format) => {
  const date = addDays(now(), days);
  return format === undefined ? date : dateFormat(date, format, {locale: getLocale()});
};

const nMonthsFromNow = (months, format) => {
  const date = addMonths(now(), months);
  return format === undefined ? date : dateFormat(date, format, {locale: getLocale()});
};

const nYearsFromNow = (years) => addYears(now(), years);


const toTimestamp = (date, format) => {
  if (!date) return undefined;
  return format === undefined
    ? getTimestamp(new Date(date))
    : getTimestamp(parse(date, format, new Date()));
};

const toDate = (ts) => new Date(parseInt(ts, 10));

const toTime = (secondsTr) => {
  const minutes = parseInt(secondsTr / 60);
  const seconds = secondsTr % 60;

  if (minutes === 0) return __("%(seconds)s sec.").format({seconds});
  return __("%(minutes)s min. %(seconds)s sec.").format({minutes, seconds});
};


const format = (date, mask) =>
  dateFormat((isNumber(date) ? toDate(date) : date), mask, {locale: getLocale()});

// Get current hours
const getCHours = (date) => getHours(date ? new Date(date) : now());

// Get current minutes
const getCMinutes = (date) => getMinutes(date ? new Date(date) : now());

// Get current seconds
const getCSeconds = (date) => getSeconds(date ? new Date(date) : now());


// Returns Date: beginning of specified day.
// -> timestamp|Date d: target date.
const makeDayStart = (d) => startOfDay(isNumber(d) ? new Date(d) : d);

// Returns Date: end of specified day.
// -> timestamp|Date d: target date.
const makeDayEnd = (d) => endOfDay(isNumber(d) ? new Date(d) : d);

// Returns Date: noon of specified day.
// -> timestamp|Date d: target date.
const makeDayNoon = (d) =>
  setSeconds(setMinutes(setHours((isNumber(d) ? new Date(d) : d), 12), 0), 0);

const makeNextDay = (d) => addDays(isNumber(d) ? new Date(d) : d, 1);

const makeDayCustomTime = (day, hours, minutes, seconds) =>
  new Date(day.getFullYear(), day.getMonth(), day.getDate(), hours, minutes, seconds);


// Year shortcuts.
const yearStart = () => startOfYear(now());

const isCurrentYear = (ts) => now().getYear() === toDate(ts).getYear();

// Today shortcuts.
const todayStart = () => makeDayStart(now());

const todayEnd = () => makeDayEnd(now());

const todayNoon = () => makeDayNoon(now());

// Yesterday shortcuts.
const yesterdayStart = () => startOfDay(subDays(now(), 1));

const yesterdayEnd = () => endOfDay(subDays(now(), 1));


// Tomorrow shortcuts.
const tomorrowStart = () => startOfDay(addDays(now(), 1));

const tomorrowEnd = () => endOfDay(addDays(now(), 1));


// Week shortcuts.
const getWeekStartsThemePickerItem = () => getLocale() && getLocale().options.weekStartsOn;

const weekStart = (date) => startOfWeek((date || now()), {weekStartsOn: getWeekStartsIndex()});

const weekEnd = (date) => endOfWeek(date || now(), {weekStartsOn: getWeekStartsIndex()});

const nextWeekStart = () => startOfWeek(addWeeks(now(), 1), {weekStartsOn: getWeekStartsIndex()});

const lastWeekStart = () => startOfWeek(subWeeks(now(), 1), {weekStartsOn: getWeekStartsIndex()});

const lastWeekEnd = (date) =>
  endOfWeek(subWeeks(date || now(), 1), {weekStartsOn: getWeekStartsIndex()});

const getDayFromTimestamp = (ts) => {
  const day = getDay(toDate(ts));
  return day ? day - 1 : 6;
};

const getMonthFromTimestamp = (ts) => getMonth(toDate(ts)) + 1;

const getYearFromTimestamp = (ts) => getYear(toDate(ts));


// Month shortcuts.
const monthStart = () => startOfMonth(now());

const lastMonthStart = () => startOfMonth(subMonths(now(), 1));

const lastMonthEnd = (date) => endOfMonth(subMonths(date || now(), 1));


const getStringMonthFromDate = (date) => {
  const month = getMonth(date) + 1;
  return +month < 10 ? `0${month}` : month;
};


// Etc.
const isSame = (ts1, ts2, gran) =>
  gran === 'day'
    ? isSameDay(ts1, ts2)
    : gran === 'week'
    ? isSameWeek(ts1, ts2)
    : isSameMonth(ts1, ts2);


const daysLeft = (date, sDate) => differenceInDays(date, sDate || now());

const monthsLeft = (date, sDate) => differenceInMonths(date, sDate || now());

const yearsLeft = (date, sDate) => differenceInYears(date, sDate || now());

const weeksLeft = (date, sDate) => differenceInWeeks(date, sDate || now());

const hoursLeft = (date, sDate) => differenceInHours(date, sDate || now());

const minutesLeft = (date, sDate) => differenceInMinutes(date, sDate || now());

const stringDateToUniversal = (stringValue) =>
  stringValue && stringValue.split("-").join("/").split(".")[0];

const getTimeAgo = (date) => {

  if (-yearsLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(years)s year ago"),
        __("v2 %(years)s years ago"),
        __("v3 %(years)s years ago"),
        -yearsLeft(date), {years: -yearsLeft(date)})
    )
  } else if (-monthsLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(months)s month ago"),
        __("v2 %(months)s months ago"),
        __("v3 %(months)s months ago"),
        -monthsLeft(date), {months: -monthsLeft(date)})
    )
  } else if (-weeksLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(weeks)s week ago"),
        __("v2 %(weeks)s weeks ago"),
        __("v3 %(weeks)s weeks ago"),
        -weeksLeft(date), {weeks: -weeksLeft(date)})
    )
  } else if (-daysLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(days)s day ago"),
        __("v2 %(days)s days ago"),
        __("v3 %(days)s days ago"),
        -daysLeft(date), {days: -daysLeft(date)})
    )
  } else if (-hoursLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(hours)s hour ago"),
        __("v2 %(hours)s hours ago"),
        __("v3 %(hours)s hours ago"),
        -hoursLeft(date), {hours: -hoursLeft(date)})
    )
  } else if (-minutesLeft(date) >= 1) {
    return (
      pngettext(
        __("v1 %(minutes)s minute ago"),
        __("v2 %(minutes)s minutes ago"),
        __("v3 %(minutes)s minutes ago"),
        -minutesLeft(date), {days: -minutesLeft(date)})
    )
  } else {
    return __("less than a minute ago")
  }
}

function getDayInFuture(dayOfWeek, fromDate = new Date()) {
  // follow the getISODay format (7 for Sunday, 1 for Monday)
  const dayOfWeekMap = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thur: 4,
    Fri: 5,
    Sat: 6,
    Sun: 7,
  };

  const offset = fromDate.getTimezoneOffset(), o = Math.abs(offset);
  const c = +((offset < 0 ? "+" : "-") + Math.floor(o / 60).toString().slice(-2));
  const fromDateUTC = addHours(setSeconds(setMinutes(setHours(startOfDay(fromDate), 13), 0), 0), c);

  const getDtt = () => {
    const d = Object.entries(dayOfWeekMap);
    const s = d
      .map((a, index) => a[0] === dayOfWeek ? c >= 10 ? index + 1 : index : null)
      .filter(i => typeof i === 'number')[0];
    return d[s][0]
  }

  // dayOfWeekMap[dayOfWeek] get the ISODay for the desired dayOfWeek
  const targetISODay = dayOfWeekMap[c >= 10 ? dayOfWeek === 'Sun' ? 'Mon' : getDtt() : dayOfWeek];
  const fromISODay = getISODay(fromDateUTC);

  const offsetDays = targetISODay - fromISODay > 0
    ? targetISODay - fromISODay
    : (!(targetISODay - fromISODay) && toTimestamp(fromDate) < toTimestamp(fromDateUTC))
      ? 0
      : 7 + targetISODay - fromISODay;

  return addDays(fromDateUTC, offsetDays);
}


export {
  FORMAT,
  format,
  isCurrentYear,
  isSame,
  isToday,
  isYesterday,
  lastMonthEnd,
  lastMonthStart,
  lastWeekEnd,
  lastWeekStart,
  nextWeekStart,
  makeDayEnd,
  makeDayStart,
  makeDayNoon,
  makeNextDay,
  makeDayCustomTime,
  addMonths,
  subDays,
  subYears,
  addDays,
  addHours,
  addYears,
  monthStart,
  nMinutesFromNow,
  nDaysFromNow,
  nMonthsFromNow,
  now,
  nYearsFromNow,
  toDate,
  todayEnd,
  todayStart,
  todayNoon,
  tomorrowStart,
  tomorrowEnd,
  toTime,
  toTimestamp,
  weekStart,
  yearStart,
  yesterdayEnd,
  yesterdayStart,
  getCHours,
  getCMinutes,
  getCSeconds,
  WORK_DAY_HOUR_START,
  WORK_DAY_HOUR_END,
  DAYS_IN_WEEK,
  getWeekDaysMapping,
  setSeconds,
  setMinutes,
  setHours,
  getDay,
  DAYS,
  getDayFromTimestamp,
  getMonth,
  getMonthFromTimestamp,
  getYearFromTimestamp,
  getStringMonthFromDate,
  getYear,
  daysLeft,
  startOfDay,
  endOfDay,
  weekEnd,
  stringDateToUniversal,
  setLocale,
  getTimeAgo,
  getDaysInMonth,
  parseISO,
  getDayInFuture,
  getDate
};
